module.exports = __webpack_public_path__ + "img/1 (134).59555d12.png";